import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import CommunicationOnePageWidget from './communicationOnePageWidget'

function CommunicationOne() {
  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                {/* <div className='container'> */}
                   <CommunicationOnePageWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default CommunicationOne